// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1qQHa","range":"MonthRangeSwitch_range__1JWEM","disabled":"MonthRangeSwitch_disabled__rzpEZ"};